import { EInvoiceAddressSchemeType } from '@components'

import { Flex, Icon, Input, Spacing, Text, Tooltip } from '@billy/design-system'
import isEmpty from 'lodash/isEmpty'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useDebouncedCallback } from '../../../../../../../../../../../../hooks/useDebouncedCallback'
import { INVOICE_CLIENT_REFERENCE_CHARACTER_LIMIT } from '../../../../../../../../constants/invoiceClientReferenceCharacterLimit'
import { useInvoiceEditorForm } from '../../../../../../../../contexts/invoiceEditorFormContext'

export const InvoiceBuyerReference = (): ReactElement | null => {
  const { t } = useTranslation()
  const { invoiceEditorForm, trackInvoiceEditor } = useInvoiceEditorForm()

  const { FormItem, watch } = invoiceEditorForm
  const [ean, eInvoiceScheme, publicEntityRoutingEnabled] = watch([
    'receiver.ean',
    'receiver.eInvoiceScheme',
    'receiver.publicEntityRoutingEnabled',
  ])

  const isDisabled = !isEmpty(ean) && publicEntityRoutingEnabled && eInvoiceScheme === EInvoiceAddressSchemeType.LWID

  const handleDebouncedInputChange = useDebouncedCallback((value: string) =>
    trackInvoiceEditor('Form - Invoice Buyer Reference typed', {
      referenceLength: value.length,
    }),
  )

  const label = (
    <Flex as="span" flexDirection="row" gap={Spacing.S4}>
      <Text colorVariant="secondary">{t('external_invoices.editor.form.field.invoice_buyer_reference.label')}</Text>
      <Tooltip label={t('external_invoices.editor.form.field.invoice_buyer_reference.tooltip.label')} placement="top">
        <Icon icon="info" size="xs" />
      </Tooltip>
    </Flex>
  )

  return (
    <FormItem
      name="buyerReference"
      label={label}
      render={({ field: { onChange, ...props } }) => {
        return (
          <Input
            {...props}
            disabled={isDisabled}
            maxLength={INVOICE_CLIENT_REFERENCE_CHARACTER_LIMIT}
            onChange={(event) => {
              onChange(event)
              handleDebouncedInputChange(event.target.value)
            }}
            size="sm"
            placeholder={t('external_invoices.editor.form.field.invoice_buyer_reference.placeholder.label')}
          />
        )
      }}
    />
  )
}
